import './InstaGrid.css'
import "../../index.css"

import React, { useEffect, useState } from 'react';
import './InstaGrid.css';

//Note: The instaGrid is meant for use within a specific film or photo subpage (Models / Real Estate / Events / etc.) 
// It is designed to display a grid of media content related to that specific category.
//and is not intended to be used from the main film or photo pages.

export default function InstaGrid({contentList, class_Name}) {
  const [selectedPost, setSelectedPost] = useState(null);

  useEffect(() => {
    if (!selectedPost) {
      return undefined;
    }

    const bodyOverflow = document.body.style.overflow;
    const documentOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = bodyOverflow;
      document.documentElement.style.overflow = documentOverflow;
    };
  }, [selectedPost]);

  return (
    <div className={`gallery-container ${class_Name || ''}`}>
      {/* 3-Column Grid Layout */}
      <div className="instagram-grid">
        {contentList.map((post) => (
          <div 
            key={post.id} 
            className="grid-item"
            onClick={() => setSelectedPost(post)}
          >
            {/* Square aspect ratio maintainer */}
            <div className="square-wrapper">
              <img
                src={post.type === 'video' ? (post.coverSrc || post.src) : post.src}
                alt="Gallery item"
                className="post-media"
              />
              
              {/* Type Indicators (Top Right Corner) */}
              {post.type === 'carousel' && (
                <div className="type-icon-badge">
                  <svg viewBox="0 0 48 48" className="svg-icon"><path d="M34.8 29.8h3.3c.3 0 .6-.1.7-.4l2-6.2c.1-.4-.1-.8-.5-.9l-11-3.5c-.3-.1-.7.1-.8.4l-2 6.2c-.1.4.1.8.5.9l7.8 2.5zm-22.9-2h20.6c.7 0 1.2-.5 1.2-1.2V12.2c0-.7-.5-1.2-1.2-1.2H11.9c-.7 0-1.2.5-1.2 1.2v14.4c0 .7.5 1.2 1.2 1.2zm-3.9 6.8h20.6c.7 0 1.2-.5 1.2-1.2v-2.2H6.8v1.2c0 .7.5 1.2 1.2 1.2z"></path></svg>
                </div>
              )}
              {post.type === 'video' && (
                <div className="type-icon-badge">
                  <svg viewBox="0 0 24 24" className="svg-icon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"></path></svg>
                </div>
              )}

              {/* Hover Interaction Overlay */}
              {/* <div className="grid-item-overlay">
                <div className="metrics-wrapper">
                  <span className="metric-count">
                    <svg viewBox="0 0 48 48" className="overlay-icon"><path d="M34.6 6c-5.7 0-10.3 4.9-12.6 8-2.3-3.1-6.9-8-12.6-8C4 6 0 11 0 17.5c0 10.1 8.2 17.7 22.1 30.5c.3.3.7.5 1.1.5s.8-.2 1.1-.5C38.2 35.2 46 27.6 46 17.5C46 11 42 6 34.6 6z"></path></svg>
                    {post.likes}
                  </span>
                  <span className="metric-count">
                    <svg viewBox="0 0 48 48" className="overlay-icon"><path d="M47.5 46.1l-2.8-11c1.8-3.3 2.8-7.1 2.8-11.1C47.5 11 37 .5 24 .5S.5 11 .5 24 11 47.5 24 47.5c4 0 7.8-1 11.1-2.8l11 2.8c.8.2 1.6-.6 1.4-1.4zm-3-22.1c0 10-8.1 18.1-18.1 18.1S8.3 34 8.3 24 16.4 5.9 26.4 5.9s18.1 8.1 18.1 18.1z"></path></svg>
                    {post.comments}
                  </span>
                </div>
              </div> */}
            </div>
          </div>
        ))}
      </div>

      {/* Basic Lightbox Modal View */}
      {selectedPost && (
        <div className="lightbox-backdrop" onClick={() => setSelectedPost(null)}>
          <button className="lightbox-close" onClick={() => setSelectedPost(null)}>&times;</button>
          <div className="lightbox-modal" onClick={(e) => e.stopPropagation()}>
            {selectedPost.type === 'video' ? (
              <video
                src={selectedPost.src}
                poster={selectedPost.coverSrc}
                className="lightbox-media"
                muted
                autoPlay
                controls
                playsInline
              />
            ) : (
              <img src={selectedPost.src} alt="Enlarged gallery view" className="lightbox-media" />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
